module.exports = __webpack_public_path__ + "img/no-land-data.50df189b.png";